"use client";
import React from "react";

/* Quarkle mark — Direction 1: three-orb glyph (84×84 viewBox). currentColor-driven. */
export function QuarkleLogo({ size = 48, className = "", style = {}, title = "Quarkle" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 84 84"
      fill="none"
      role="img"
      aria-label={title}
      className={className}
      style={{ display: "block", color: "currentColor", flexShrink: 0, ...style }}
    >
      {/* small orb top-right */}
      <circle cx="62" cy="18" r="10" stroke="currentColor" strokeWidth="3" />
      {/* striped orb top-left */}
      <circle cx="20" cy="24" r="14" stroke="currentColor" strokeWidth="3" />
      <line x1="10" y1="22" x2="30" y2="22" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="8" y1="27" x2="24" y2="27" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      {/* big banded orb bottom */}
      <circle cx="46" cy="58" r="22" stroke="currentColor" strokeWidth="3" />
      <path d="M27 52 Q37 47 47 52 T67 54" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      <path d="M25 62 Q37 57 47 62 T69 62" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      <path d="M28 70 Q38 66 48 70" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    </svg>
  );
}

/* Quarkle wordmark — Direction 1: Gambarino, "Q" + italic "uar" + "kle". */
export function QuarkleWordmark({ size = 40, className = "", style = {}, as: Tag = "span" }) {
  return (
    <Tag
      className={`font-gambarino ${className}`}
      style={{
        fontSize: size,
        lineHeight: 0.9,
        letterSpacing: "-0.04em",
        fontWeight: 400,
        display: "inline-block",
        ...style,
      }}
    >
      Q<span style={{ fontStyle: "italic" }}>uar</span>kle
    </Tag>
  );
}

/* Convenience: mark + wordmark in the standard nav lockup. */
export function QuarkleLockup({ logoSize = 42, textSize = 34, gap = 12, className = "", style = {} }) {
  return (
    <span
      className={className}
      style={{ display: "inline-flex", alignItems: "center", gap, ...style }}
    >
      <QuarkleLogo size={logoSize} />
      <QuarkleWordmark size={textSize} />
    </span>
  );
}
